import { debounce } from '@westwing/ui-kit/utils';
import { ProductInterface } from '../../client/redux/products/types';
import { OptionalECProductValues, EcommerceProduct, AddImpressedProduct } from './types';
import normalizeGaProduct from './normalize';
import GaTracking from './index';

export const IMPRESSION_DELAY = 500;
export const MAX_BUFFER_SIZE = 40;

const getImpressionHandler = (gaTracker: GaTracking): AddImpressedProduct => {
    let buffer: EcommerceProduct[] = [];

    const track = () => {
        gaTracker.trackEcProductImpressions(buffer);
        buffer = [];
    };

    const debouncedTrack = debounce(track, IMPRESSION_DELAY);

    const pushToBuffer = (product: EcommerceProduct) => {
        buffer.push(product);

        // There is a payload size threshold on ga("gtmId.send") options, if the impressions sent
        // at once are too large it will cross this threshold, so we clear the buffer
        if (buffer.length >= MAX_BUFFER_SIZE) {
            track();
        } else {
            debouncedTrack();
        }
    };

    const addImpressedProduct = (product: ProductInterface, options: OptionalECProductValues) =>
        pushToBuffer(normalizeGaProduct(product, options));

    return addImpressedProduct;
};

export default getImpressionHandler;
